module.exports = "/pages/business/foodslabo/support_image_3.png";